// ─────────────────────────────────────────────────────────────────────────────
// riggingStorage.js — Local-storage persistence for per-boat/per-seat rigging.
//
// Storage shape:
//   localStorage["oarlockRig"] = JSON.stringify({
//     "BOAT1_STN1": { ol: 288, ib: 88, sp: 87, zf: 0, za: 0, pcal: false, mfw2: true, side: 'port' },
//     "BOAT1_STN2": { ol: 290, ib: 87, sp: 87, zf: 0, za: 0, pcal: true,  mfw2: false, side: 'stbd' },
//   })
//
// Backend remains the source of truth; this is a write-through cache so the
// algorithm layer can run offline / pre-login.
// ─────────────────────────────────────────────────────────────────────────────

const KEY = 'oarlockRig';

const SHORT_SIDE = { port: 'port', starboard: 'stbd', sweep: 'sweep', single_scull: 'single' };

export function rigKey(boatId, seatNumber) {
  return `${(boatId || 'BOAT1').toUpperCase()}_STN${Number(seatNumber) || 1}`;
}

export function loadAllRigs() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return {};
    return JSON.parse(raw) || {};
  } catch {
    return {};
  }
}

export function loadRig(boatId, seatNumber) {
  return loadAllRigs()[rigKey(boatId, seatNumber)] || null;
}

export function saveRig(boatId, seatNumber, rig) {
  const all = loadAllRigs();
  all[rigKey(boatId, seatNumber)] = rig;
  try {
    localStorage.setItem(KEY, JSON.stringify(all));
    return true;
  } catch {
    return false;
  }
}

export function deleteRig(boatId, seatNumber) {
  const all = loadAllRigs();
  delete all[rigKey(boatId, seatNumber)];
  try {
    localStorage.setItem(KEY, JSON.stringify(all));
    return true;
  } catch {
    return false;
  }
}

/**
 * Convert a backend OarlockConfig payload to the canonical localStorage rig shape.
 */
export function backendConfigToRig(cfg) {
  if (!cfg) return null;
  return {
    ol: Number(cfg.oar_length_cm),
    ib: Number(cfg.inboard_cm),
    sp: cfg.spread_cm == null ? null : Number(cfg.spread_cm),
    zf: cfg.set_zero_force == null ? 0 : Number(cfg.set_zero_force),
    za: cfg.set_zero_angle == null ? 0 : Number(cfg.set_zero_angle),
    pcal: !!cfg.pin_calibration,
    mfw2: !!cfg.multiply_fwp_by_2,
    side: SHORT_SIDE[cfg.side] || cfg.side,
    vendor: cfg.vendor,
  };
}
